import React from "react"
import { ExternalLink } from "@mallardbay/lib-react-components"

import Span from "~components/shared/todo-lib-react-components/span"

interface Props {
    readonly configs: {
        text: string
        url?: string | null
    }[]
}

export default function TextWithExternalLinks({ configs }: Props) {
    return (
        <div>
            {configs.map(({ text, url }) => {
                if (!url) {
                    return <Span key={text}>{text}</Span>
                }

                return (
                    <ExternalLink key={text} href={url} isUnderlined>
                        {text}
                    </ExternalLink>
                )
            })}
        </div>
    )
}
